import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('ol', 'dropdownList', 'dropdown')`
    ${propStyles};
    list-style: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
`;

StyledComponent.defaultProps = {
    maxHeight: '300px',
    overflowX: 'hidden',
    overflowY: 'auto',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Dropdown/StyledComponents/DropdownList.tsx